import { ComingSoonPlaceholder } from "../../../../shared/components/placeholders/ComingSoonPlaceholder"
import DashboardAnimation from "../../../merchant/merchant/assets/animation_ljyatnb9.json"
import { MatchEnvironment } from "../../../environment/components/MatchEnvironment"
import { LocalizedStrict } from "../../../localization/components/AppLocalized"
import { Dashboard } from "../../../dashboards/components/Dashboard"
import { EnvironmentType } from "../../../environment/envTypes"
import { DeviceReport } from "../components/DeviceReport"

type HomeProps = Readonly<{}>

export function SupplierReportsHome({}: HomeProps) {
    return (
        <Dashboard>
            <DeviceReport />
        </Dashboard>
    )
}
